export default __webpack_public_path__ + "static/media/refectori-espleni-03.e7d1ad6d.jpg";